import React from 'react';
import * as S from './style';
import * as T from '../Typography';
import { useSiteSettings } from 'context/site-settings';

const YoutubeVid = ({
  videoUrl,
  videoId,
  onVideoEnd,
  autoPlay = 1,
  ...props
}) => {
  const { isWorkingInPrisonEnvironment } = useSiteSettings();
  // Get videoId from the URL supporting different youtube url versions
  const videoIdRegex =
    /(?:youtu\.be\/|youtube\.com\/(?:embed\/|watch\?v=|v\/|.+&v=|live\/))([^&?/]+)/;

  // Extract the video ID from the YouTube URL
  const _videoId = videoId || videoUrl.match(videoIdRegex)?.[1];

  const opts = {
    width: '100%',
    height: '100%',
    playerVars: {
      autoplay: autoPlay,
    },
  };

  const handleVideoEnd = (event) => {
    if (onVideoEnd) {
      onVideoEnd();
    }
  };

  if (isWorkingInPrisonEnvironment) {
    // mark video as played
    typeof props.onPlay === 'function' && props.onPlay();
    typeof onVideoEnd === 'function' && onVideoEnd();

    return (
      <S.PlaceHolderContainer>
        <T.P>Sorry, this video is not available in this environment</T.P>
      </S.PlaceHolderContainer>
    );
  }

  if (!_videoId) {
    return (
      <S.VideoContainer>
        <T.P>Invalid YouTube URL</T.P>
      </S.VideoContainer>
    );
  }

  return (
    <S.VideoContainer>
      <S.StyledYouTube
        videoId={_videoId}
        opts={opts}
        onEnd={handleVideoEnd}
        {...props}
      />
    </S.VideoContainer>
  );
};

export default YoutubeVid;
